import { render, staticRenderFns } from "./AdvertisementListComponent.vue?vue&type=template&id=45793842&scoped=true&"
import script from "./AdvertisementListComponent.vue?vue&type=script&lang=js&"
export * from "./AdvertisementListComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisementListComponent.vue?vue&type=style&index=0&id=45793842&prod&scoped=true&lang=css&"
import style1 from "./AdvertisementListComponent.vue?vue&type=style&index=1&id=45793842&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45793842",
  null
  
)

export default component.exports